import type { ClientPost } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineHappeningEventsApi } from '@/features/api/hooks/grapevine-happening-events/useGrapevineHappeningEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useAnnounceHappeningParticipation = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineHappeningEventsApi();

  return useApiMutation({
    mutationFn: (happeningId: string) =>
      api.onHappeningParticipationConfirmRequest({
        clientHappeningParticipationConfirmRequest: { happeningId }
      }),
    errorMessageKey: 'announceHappeningParticipation.error',
    onSuccess: (data, postId) => {
      queryClient.setQueryData(
        [API_CACHE_KEYS.POST, { postId }],
        (prev: ClientPost) => {
          if (!prev) return prev;
          return {
            ...prev,
            happening: {
              ...prev.happening,
              participated: data.updatedHappening.happening?.participated,
              participantCount:
                data.updatedHappening.happening?.participantCount
            }
          };
        }
      );
      queryClient.invalidateQueries({
        queryKey: [
          API_CACHE_KEYS.HAPPENING_PARTICIPANTS,
          { happeningId: postId }
        ]
      });
    }
  });
};
